<template>
  <div class="m-header">
    <div @click="changePage(item.value)" class="header-item" :class="currentRoute === item.value ? 'header-item-actived' : ''" 
          v-for="(item, index) in headerList" :key="index">{{item.title}}</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      headerList: [{
        title: '解决方案',
        value: 'solution'
      }, {
        title: '合作案例',
        value: 'case'
      }, {
        title: '合作支持',
        value: 'support'
      },
      {
        title: '关于我们',
        value: 'about'
      }]
    }
  },
  computed: {
    currentRoute() {
      return this.$route.params.type || 'index'
    }
  },
  methods: {
    changePage(type) {
      this.$emit('changePages', type)
    }
  }
}
</script>
<style lang="scss" scoped>
.m-header {
  width: 100%;
  height: .82rem;
  padding: 0 .48rem;
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-size: .29rem;
  font-weight: 600;
  color: #393332;
  background: #F7F9F9;
  box-shadow: 0px 1px .03rem 0px rgba(128, 127, 127, 0.27);
  .header-item {
    height: .82rem;
    line-height: .86rem;
    border-bottom: .04rem solid transparent;
  }
  .header-item-actived {
    color: #217CFE;
    border-bottom: .04rem solid #217CFE;
  }
}
</style>